import { render, staticRenderFns } from "./KaiPrimaryCtaButton.vue?vue&type=template&id=12b66af9&scoped=true&"
var script = {}
import style0 from "./KaiPrimaryCtaButton.vue?vue&type=style&index=0&id=12b66af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b66af9",
  null
  
)

export default component.exports